module.exports = __webpack_public_path__ + "img/lw.c140dd5e.png";